import { CartStore } from '../store/cart-store';
import { CheckoutStore } from '../store/checkout-store';
import PhoneInputService from './phone-input-service';
import PreloaderService from './preloader-service';
import Sliders from './swiper-init';
export default class CheckoutService {
    constructor() {
        this.stepsHistory = [];
        this.isCheckoutPage = !!document.querySelector('.checkout');
        this.preloader = new PreloaderService('#main-wrapper');
        if (this.isCheckoutPage && this.preloader) {
            this.preloader.show();
        }
    }
    initCommentsAccordion() {
        const commentAccordion = document.querySelector('.payment-comment-accordion');
        if (!commentAccordion) {
            return;
        }
        commentAccordion.addEventListener('click', (event) => {
            var _a;
            const el = event.target;
            (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.classList.toggle('show');
        });
    }
    hideAllForms() {
        const state = CheckoutStore.getState();
        const steps = (state === null || state === void 0 ? void 0 : state.steps) || {};
        Object.values(steps).forEach((s) => {
            var _a, _b;
            (_b = (_a = s === null || s === void 0 ? void 0 : s.el) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('hide');
        });
    }
    getCurrentStep() {
        return this.stepsHistory[this.stepsHistory.length - 1];
    }
    showForm(form) {
        if (!form) {
            return;
        }
        this.hideAllForms();
        form.classList.remove('hide');
        if (this.stepsHistory[this.stepsHistory.length - 1] !== form.id) {
            this.stepsHistory.push(form.id);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
    cleanupValidation(form) {
        form.querySelectorAll('.input-container').forEach((el) => {
            var _a;
            if (el.classList.contains('error') || el.classList.contains('success')) {
                el.classList.remove('error', 'success');
                (_a = el.querySelector('.desc')) === null || _a === void 0 ? void 0 : _a.remove();
            }
        });
    }
    initNavigation() {
        window.history.replaceState(null, '', window.location.pathname);
        const backBtn = document.querySelector('.checkout-nav-back');
        const onUpdateCHeckoutSteps = () => {
            const state = CheckoutStore.getState();
            const currentStep = this.getCurrentStep() || 'form_client_data';
            const stepsContainer = document.querySelector('.checkout-container');
            this.preloader.show();
            stepsContainer === null || stepsContainer === void 0 ? void 0 : stepsContainer.classList.add('hide');
            state
                .sendForm('update_checkout_steps', { step: currentStep })
                .then((response) => {
                const responseData = response === null || response === void 0 ? void 0 : response.data;
                this.updateStepsList(responseData === null || responseData === void 0 ? void 0 : responseData.steps_html);
            })
                .catch(console.log)
                .finally(() => {
                stepsContainer === null || stepsContainer === void 0 ? void 0 : stepsContainer.classList.remove('hide');
                this.preloader.hide();
            });
        };
        backBtn === null || backBtn === void 0 ? void 0 : backBtn.addEventListener('click', (event) => {
            const state = CheckoutStore.getState();
            const formState = state.steps[this.stepsHistory[this.stepsHistory.length - 2]];
            if (!this.stepsHistory.length || !formState || !formState.el) {
                window.history.back();
            }
            else {
                event.preventDefault();
                event.stopPropagation();
                const form = formState.el;
                this.stepsHistory.splice(-2);
                this.showForm(form);
                onUpdateCHeckoutSteps();
                this.cleanupValidation(form);
            }
        });
        document.body.addEventListener('click', (event) => {
            var _a;
            const target = event.target;
            const changeBtn = target.closest('.checkout-steps-list-item button');
            if (target && changeBtn && ((_a = changeBtn === null || changeBtn === void 0 ? void 0 : changeBtn.dataset) === null || _a === void 0 ? void 0 : _a.stepRelation)) {
                const state = CheckoutStore.getState();
                const form = state.steps[changeBtn.dataset.stepRelation].el;
                this.showForm(form);
                onUpdateCHeckoutSteps();
                this.cleanupValidation(form);
            }
        });
    }
    serializeFormData(form) {
        if (!form) {
            return {};
        }
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        return data;
    }
    updateStepsList(stepsHtml) {
        const stepsListEl = document.querySelector('.checkout-steps');
        if (stepsListEl && stepsHtml) {
            const newElement = document.createElement('div');
            newElement.className = 'checkout-steps';
            newElement.innerHTML = stepsHtml;
            stepsListEl.replaceWith(...newElement.childNodes);
        }
    }
    updateFormListItems(form, selector, rawHtml) {
        if (!form) {
            return;
        }
        const listContainer = form.querySelector(selector);
        if (!listContainer || !rawHtml) {
            return;
        }
        listContainer.innerHTML = rawHtml;
    }
    initListeners() {
        const phoneInputService = new PhoneInputService();
        phoneInputService.initPhoneInputs();
        this.initCommentsAccordion();
        this.initInpostWidget();
    }
    onClientDataFormSubmit(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const submitter = event.submitter;
        if (!submitter || submitter.type !== 'submit') {
            return;
        }
        submitter.disabled = true;
        const data = this.serializeFormData(form);
        const state = CheckoutStore.getState();
        state.updateForm('form_client_data', { formData: data });
        const nextForm = state.steps.form_delivery.el;
        this.preloader.show();
        state
            .sendForm(form.id, data)
            .then((response) => {
            const responseData = response === null || response === void 0 ? void 0 : response.data;
            this.updateStepsList(responseData === null || responseData === void 0 ? void 0 : responseData.steps_html);
            if (!response.success) {
                if (responseData === null || responseData === void 0 ? void 0 : responseData.current_step_html) {
                    form.innerHTML = responseData === null || responseData === void 0 ? void 0 : responseData.current_step_html;
                    this.initListeners();
                    Sliders.initCheckoutSlider();
                }
                return;
            }
            if (responseData === null || responseData === void 0 ? void 0 : responseData.next_step_html) {
                nextForm.innerHTML = responseData === null || responseData === void 0 ? void 0 : responseData.next_step_html;
                this.initListeners();
                this.showForm(nextForm);
            }
        })
            .catch(console.error)
            .finally(() => {
            submitter.disabled = false;
            this.preloader.hide();
        });
    }
    onDeliveryFormSubmit(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const submitter = event.submitter;
        if (!submitter || submitter.type !== 'submit') {
            return;
        }
        submitter.disabled = true;
        const data = this.serializeFormData(form);
        const state = CheckoutStore.getState();
        state.updateForm('form_delivery', { formData: data });
        const nextForm = state.steps.form_payment.el;
        this.preloader.show();
        state
            .sendForm(form.id, data)
            .then((response) => {
            const responseData = response === null || response === void 0 ? void 0 : response.data;
            this.updateStepsList(responseData === null || responseData === void 0 ? void 0 : responseData.steps_html);
            if (!response.success) {
                if (responseData === null || responseData === void 0 ? void 0 : responseData.current_step_html) {
                    form.innerHTML = responseData === null || responseData === void 0 ? void 0 : responseData.current_step_html;
                    this.initListeners();
                }
                return;
            }
            if (responseData === null || responseData === void 0 ? void 0 : responseData.next_step_html) {
                nextForm.innerHTML = responseData === null || responseData === void 0 ? void 0 : responseData.next_step_html;
                this.initListeners();
                this.showForm(nextForm);
            }
        })
            .catch(console.error)
            .finally(() => {
            submitter.disabled = false;
            this.preloader.hide();
        });
    }
    onPaymentFormSubmit(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const submitter = event.submitter;
        if (!submitter || submitter.type !== 'submit') {
            return;
        }
        submitter.disabled = true;
        const data = this.serializeFormData(form);
        const state = CheckoutStore.getState();
        state.updateForm('form_payment', { formData: data });
        const nextForm = state.steps.form_client_data.el;
        this.preloader.show();
        CheckoutStore.getState()
            .sendForm(form.id, data)
            .then((response) => {
            var _a;
            const responseData = response === null || response === void 0 ? void 0 : response.data;
            this.updateStepsList(responseData === null || responseData === void 0 ? void 0 : responseData.steps_html);
            if (!response.success) {
                if (responseData === null || responseData === void 0 ? void 0 : responseData.current_step_html) {
                    form.innerHTML = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.current_step_html) !== null && _a !== void 0 ? _a : '';
                    this.initListeners();
                }
                return;
            }
            if (response.success) {
                if (responseData === null || responseData === void 0 ? void 0 : responseData.redirect_url) {
                    window.location.assign(responseData.redirect_url);
                }
            }
        })
            .catch(console.error)
            .finally(() => {
            submitter.disabled = false;
            this.preloader.hide();
        });
    }
    onOrderReceived(data) {
        CheckoutStore.getState()
            .sendForm('order_received', data)
            .then((response) => {
            const responseData = response === null || response === void 0 ? void 0 : response.data;
            const checkoutContainer = document.querySelector('.checkout-container');
            if (checkoutContainer) {
                checkoutContainer.innerHTML = responseData === null || responseData === void 0 ? void 0 : responseData.current_step_html;
                const trackingData = (responseData === null || responseData === void 0 ? void 0 : responseData.tracking_data) || {};
                const { currency, value, coupon, shipping_tier, payment_type, shipping, order_type, items } = trackingData;
                const parsedValue = parseFloat(value) || 0;
                const parsedShipping = parseFloat(shipping) || 0;
                if (trackingData) {
                    const { currency, value, coupon, shipping_tier, payment_type, shipping, order_type, items, transaction_id, } = trackingData;
                    const coupon_convert = coupon === 'none' ? undefined : coupon;
                    if (transaction_id) {
                        const firedTransactions = JSON.parse(localStorage.getItem('firedTransactions') || '[]');
                        if (!firedTransactions.includes(transaction_id)) {
                            pushEcommerceEvent({
                                eventName: 'purchase',
                                transaction_id,
                                currency,
                                value: parseFloat(value) || 0,
                                coupon: coupon_convert,
                                shipping_tier,
                                payment_type,
                                shipping: parseFloat(shipping) || 0,
                                order_type,
                                items,
                            });
                            firedTransactions.push(transaction_id);
                            localStorage.setItem('firedTransactions', JSON.stringify(firedTransactions));
                            CartStore.getState().fetchCart();
                        }
                        else {
                            console.log(`pushEcommerceEvent already fired for transaction ID: ${transaction_id}`);
                        }
                    }
                }
            }
        })
            .catch(console.error)
            .finally(console.info);
    }
    extractOrderData() {
        var _a, _b;
        const params = Object.fromEntries(new URLSearchParams(window.location.search));
        if (typeof params.key !== 'undefined') {
            return Object.assign(Object.assign({}, params), { pathname: (_b = (_a = window.location.pathname) === null || _a === void 0 ? void 0 : _a.replace('/checkout/', '')) === null || _b === void 0 ? void 0 : _b.split('/') });
        }
        return false;
    }
    setupSteps() {
        const state = CheckoutStore.getState();
        const stepsForms = document.querySelectorAll(state.getFormIds());
        const [clientDataForm, deliveryForm, paymentForm] = stepsForms;
        state.updateForm('form_client_data', { el: clientDataForm });
        state.updateForm('form_delivery', { el: deliveryForm });
        state.updateForm('form_payment', { el: paymentForm });
        clientDataForm === null || clientDataForm === void 0 ? void 0 : clientDataForm.addEventListener('submit', (event) => this.onClientDataFormSubmit(event));
        deliveryForm === null || deliveryForm === void 0 ? void 0 : deliveryForm.addEventListener('submit', (event) => this.onDeliveryFormSubmit(event));
        paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm.addEventListener('submit', (event) => this.onPaymentFormSubmit(event));
        const orderData = this.extractOrderData();
        if (orderData) {
            this.onOrderReceived(orderData);
        }
        else {
            this.showForm(clientDataForm);
        }
    }
    initInpostWidget() {
        var _a, _b, _c, _d, _e, _f, _g;
        window.selectPointCallback = function (point) {
            var _a, _b, _c, _d, _e, _f;
            const parcelMachineAddressDesc = (_a = point.location_description) !== null && _a !== void 0 ? _a : '';
            const visible_point_data = `${(_b = point.name) !== null && _b !== void 0 ? _b : ''}, ${(_d = (_c = point.address) === null || _c === void 0 ? void 0 : _c.line1) !== null && _d !== void 0 ? _d : ''}, ${(_f = (_e = point.address) === null || _e === void 0 ? void 0 : _e.line2) !== null && _f !== void 0 ? _f : ''}, <em>${parcelMachineAddressDesc}</em>`;
            document.querySelectorAll('input[name=parcel_machine_id]').forEach((el) => {
                el.value = point.name;
            });
            document.querySelectorAll('input[name=parcel_machine_desc]').forEach((el) => {
                el.value = parcelMachineAddressDesc;
            });
            document.querySelectorAll('[id*=selected-parcel-machine]').forEach((el) => {
                el.classList.remove('hidden-paczkomat-data');
            });
            document.querySelectorAll('[id*=selected-parcel-machine-id]').forEach((el) => {
                el.innerHTML = visible_point_data;
            });
            const EasyPackPointObject = {
                pointName: point.name,
                pointDesc: parcelMachineAddressDesc,
                visiblePointData: visible_point_data,
            };
            localStorage.setItem('EasyPackPointObject', JSON.stringify(EasyPackPointObject));
            const deliveryMethodRadio = Array.from(document.querySelectorAll('input[name="delivery"]'));
            const matchingRadio = deliveryMethodRadio.find((radio) => radio.value.includes('easypack_parcel_machines'));
            if (matchingRadio) {
                matchingRadio.checked = true;
            }
            if (window.geowidgetModal) {
                window.geowidgetModal.close();
            }
        };
        (_a = document.querySelector('#easypack_show_geowidget')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (e) => {
            e.preventDefault();
            if (window.geowidgetModal && !window.geowidgetModal.isOpen) {
                setTimeout(() => {
                    window.geowidgetModal.open();
                }, 500);
            }
        });
        const wH = window.innerHeight - 100;
        const token = (_c = (_b = window.InpostData) === null || _b === void 0 ? void 0 : _b.token) !== null && _c !== void 0 ? _c : '';
        const widgetWidth = (_e = (_d = window.InpostData) === null || _d === void 0 ? void 0 : _d.width) !== null && _e !== void 0 ? _e : '';
        const config = (_g = (_f = window.InpostData) === null || _f === void 0 ? void 0 : _f.config) !== null && _g !== void 0 ? _g : {};
        try {
            const jbox = window.jBox;
            if (jbox) {
                window.geowidgetModal = new jbox('Modal', {
                    width: widgetWidth,
                    height: wH,
                    attach: '#easypack_show_geowidget',
                    title: 'Choose a post office',
                    content: `<inpost-geowidget id="inpost-geowidget" onpoint="selectPointCallback"
        token="${token}"
        language="pl"
        config="${config}"></inpost-geowidget>`,
                });
            }
        }
        catch (e) {
            console.error(e, 'window.jBox error');
        }
    }
    init(modalService) {
        try {
            this.modalService = modalService;
            if (this.isCheckoutPage) {
                this.modalService.observeChanges();
                this.preloader.show();
                this.setupSteps();
                this.initCommentsAccordion();
            }
            this.initNavigation();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.preloader.hide();
        }
    }
}
